export const GET_KNOWLEDGE_CENTER = "GET_KNOWLEDGE_CENTER"
export const GET_KNOWLEDGE_CENTER_SUCCESS = "GET_KNOWLEDGE_CENTER_SUCCESS"
export const GET_KNOWLEDGE_CENTER_FAIL = "GET_KNOWLEDGE_CENTER_FAIL"

export const GET_COMPANY_KNOWLEDGE_GUIDE = "GET_COMPANY_KNOWLEDGE_GUIDE"
export const GET_COMPANY_KNOWLEDGE_GUIDE_SUCCESS = "GET_COMPANY_KNOWLEDGE_GUIDE_SUCCESS"
export const GET_COMPANY_KNOWLEDGE_GUIDE_FAILED = "GET_COMPANY_KNOWLEDGE_GUIDE_FAILED"


export const GET_KNOWLEDGE_GUIDE_LINKS = "GET_KNOWLEDGE_GUIDE_LINKS"
export const GET_KNOWLEDGE_GUIDE_LINKS_SUCCESS = "GET_KNOWLEDGE_GUIDE_LINKS_SUCCESS"
export const GET_KNOWLEDGE_GUIDE_LINKS_FAILED = "GET_KNOWLEDGE_GUIDE_LINKS_FAILED"